import React from "react";

const TopButton = () => {
  return (
    <div>
      <a id='button' href='...'>
        <i class='material-icons top-btn'>navigation</i>
      </a>
    </div>
  );
};

export default TopButton;
